<mat-form-field class="example-full-width">
    <input type="text"  #focused
           aria-label="Number"
           matInput
           [formControl]="fieldCtrl"
           placeholder="{{ placeHolder  }}"
           (keyup)="onSelect($event)"
           [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
     <mat-option *ngFor="let element of filteredList | async" [value]="element" (click)="onSelect(element)"
			[title]="config.display">{{element[config.display]}}
		</mat-option>
    <mat-option [value]="" (click)="onSelect({id: -1})" *ngIf="action">
      <div class="btn btn-success btn-sm btn-action">{{action}}</div>
    </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- [displayWith]="getTitle.bind(this)" -->